module.exports = __webpack_public_path__ + "static/frank-curriero-1a1db43fbec248a3887f11fa3ddbc235.png";